import { TemplateKey } from "../template-keys";
import { FontSizeGroup, FontSizeKey } from "../font-size.config";
export type InvitationThemeConfig = {
    /**
     * the polltemplate that may use this design - if null it's valid for all templates.
     * The family is already gated by the layout (R5, concept-layout-switch-invitation-2026-10-01);
     * `validForTemplates` is only for themes that are additionally limited to single templates.
     */
    validForTemplates?: string[];
    filterKeywords?: string[]; // keyword bason on which the theme can be filtered -  for example on the landing pages
    picture?: string;
    previewPicture?: string; // if not there value from "picutre" will be used
    pictureSmallScreen?: string; // if not there value from "picutre" will be used
    colorPalette?: string;
    pollStyleKey?: string;
    /**
     * Theme defaults of the header settings "font size" and "uppercase" (workorder-font-size-setting-2026-09-14,
     * workorder-header-uppercase-toggle-2026-09-15, Nachtrag "Theme-Defaults"). Precedence like colorPalette /
     * pollStyleKey: a value in the poll header wins, then the theme, then m / uppercase. A theme default applies
     * IMMEDIATELY to every existing poll with that theme (nothing is written to the header) - check the poll
     * numbers before adding one to a theme that is already in use.
     */
    fontSize?: FontSizeKey; // preset for all groups
    fontSizes?: Partial<Record<FontSizeGroup, FontSizeKey>>; // per group, overrides fontSize for that group
    disableUppercase?: boolean; // true = title/subtitle/boxes rendered as typed
    backgroundSizeKeyBigScreen?: string;
    backgroundSizeKeySmallScreen?: string;
    leftStyle?: {
        backgroundContainer?: any;
        contentContainerBigScreen?: any;
        contentContainerSmallScreen?: any;
        backgroundBox?: any;
        pollTitle?: any;
        pollDescription?: any;
        whenBox?: any;
        whereBox?: any;
        whereTitle?: any;
        respondTillStamp?: any;
        respondTillDate?: any;
        respondTillTitle?: any;
        commentsBox?: any;
        commentsTitle?: any;
    }
}



export const invitationThemeMap = new Map<string, InvitationThemeConfig>([

    ['custom', {
        colorPalette: "default",
        validForTemplates: [TemplateKey.none],
        filterKeywords: [],
        picture: '',
        pollStyleKey: "invite-background-white-transparent",
        backgroundSizeKeyBigScreen: 'cover',

    }],
    ['no-theme', {
        filterKeywords: [],
        previewPicture: '/assets/images/poll-templates/theme-preview/no-theme-preview.webp',
        picture: '',
        colorPalette: 'default',
    }],
    ['barbecue', {
        colorPalette: "yellow-white",
        filterKeywords: [],
        picture: '/assets/images/poll-templates/invitation/barbeque-dark-2.webp',
        backgroundSizeKeyBigScreen: 'cover',
        backgroundSizeKeySmallScreen: '100-auto',

    }],
    ['ballons', {
        filterKeywords: ['birthday'],
        picture: '/assets/images/poll-templates/invitation/colorful-party-balloons.webp',
        previewPicture: '/assets/images/poll-templates/theme-preview/ballons.webp',
        colorPalette: "red-black-yellow",
        pollStyleKey: "invite-background-white-transparent",
        backgroundSizeKeyBigScreen: 'cover',
        backgroundSizeKeySmallScreen: 'cover',



    }],
    ['barbecue-veggie', {
        filterKeywords: [],
        picture: '/assets/images/poll-templates/invitation/grilled-tasty-asssorted-vegetab.webp',
        colorPalette: "yellow-white",
        pollStyleKey: "invite-blur-8",
        backgroundSizeKeyBigScreen: 'cover',
        backgroundSizeKeySmallScreen: 'cover'
    }],
    ['thanksgiving-dinner', {
        filterKeywords: [],
        picture: '/assets/images/poll-templates/invitation/thanksgiving-dinner.webp',
        colorPalette: "yellow-white",
        backgroundSizeKeyBigScreen: 'cover',
        backgroundSizeKeySmallScreen: 'cover'

    }],
    ['festive-dinner', {
        filterKeywords: ['birthday'],
        picture: '/assets/images/poll-templates/invitation/table-setting-for-a-festive-dinner.webp',
        colorPalette: "yellow-white",
        pollStyleKey: "invite-blur-8",
        backgroundSizeKeyBigScreen: 'cover',
        backgroundSizeKeySmallScreen: 'cover'

    }],
    ['wedding-wedding-bouquet', {
        filterKeywords: [],
        picture: '/assets/images/poll-templates/invitation/man-and-woman-with-wedding-bouquet.webp',
        colorPalette: "yellow-white",
        pollStyleKey: "invite-blur-8",
        backgroundSizeKeyBigScreen: 'cover',
        backgroundSizeKeySmallScreen: 'cover'
    }],
    ['halloween-table-with-pumpkin', {
        filterKeywords: [],
        picture: '/assets/images/poll-templates/invitation/halloween-table-with-punpkin.webp',
        colorPalette: "yellow-white",
        pollStyleKey: "invite-blur-8",
        backgroundSizeKeyBigScreen: 'cover',
        backgroundSizeKeySmallScreen: 'cover'
    }],
    ['vine-glasses', {
        filterKeywords: [],
        picture: '/assets/images/poll-templates/invitation/glasses-with-various-craft-wine.webp',
        colorPalette: "yellow-white",
        pollStyleKey: "invite-blur-8",
        backgroundSizeKeyBigScreen: 'cover',
        backgroundSizeKeySmallScreen: 'cover'
    }],
    ['turntable', {
        filterKeywords: [],
        picture: '/assets/images/poll-templates/invitation/disc-jockey-at-the-turntable.webp',
        colorPalette: "yellow-white",
        pollStyleKey: "invite-blur-12",
        backgroundSizeKeyBigScreen: 'cover',
        backgroundSizeKeySmallScreen: 'cover'

    }],
    ['disc-jockey', {
        filterKeywords: [],
        picture: '/assets/images/poll-templates/invitation/disco-dj-playing.webp',
        colorPalette: "red-black-yellow",
        pollStyleKey: "invite-blur-12",
        backgroundSizeKeyBigScreen: '100-auto',
        backgroundSizeKeySmallScreen: '100-auto'
    }],
    ['business-people', {
        filterKeywords: [],
        picture: '/assets/images/poll-templates/invitation/group-of-business-people.webp',
        colorPalette: "yellow-white",
        pollStyleKey: "invite-blur-12",
        backgroundSizeKeyBigScreen: 'cover',
        backgroundSizeKeySmallScreen: '100-auto'

    }],
    ['fireworks', {
        filterKeywords: [],
        picture: '/assets/images/poll-templates/invitation/firework-show-on-new-years-eve.webp',
        colorPalette: "yellow-white",
        pollStyleKey: "invite-blur-2",
        backgroundSizeKeyBigScreen: 'cover',
        backgroundSizeKeySmallScreen: 'cover'
    }],
    ['kids', {
        filterKeywords: ['birthday'],
        picture: '/assets/images/poll-templates/generic-poll/kids.webp',
        colorPalette: "yellow-white",
        pollStyleKey: "invite-blur-12",
        backgroundSizeKeyBigScreen: '100-auto',
        backgroundSizeKeySmallScreen: '100-auto'
    }],
    ['friendsgiving', {
        filterKeywords: [],
        picture: '/assets/images/poll-templates/generic-poll/friendsgiving.jpg',
        colorPalette: "red",
        pollStyleKey: "invite-blur-8",
        backgroundSizeKeyBigScreen: 'cover',
        backgroundSizeKeySmallScreen: 'cover'
    }],
    ['easter-eggs', {
        filterKeywords: [],
        picture: '/assets/images/poll-templates/generic-poll/easter-eggs.jpg',
        colorPalette: "red-black-yellow",
        pollStyleKey: "invite-blur-8",
        backgroundSizeKeyBigScreen: 'cover',
        backgroundSizeKeySmallScreen: 'cover'
    }],
    ['valentine-hearts', {
        filterKeywords: [],
        picture: '/assets/images/poll-templates/generic-poll/valentine-hearts.jpg',
        colorPalette: "yellow",
        pollStyleKey: "invite-blur-8",
        backgroundSizeKeyBigScreen: 'cover',
        backgroundSizeKeySmallScreen: 'cover'
    }],
    ['4th-of-july', {
        filterKeywords: [],
        picture: '/assets/images/poll-templates/invitation/4th-of-july.jpg',
        colorPalette: "yellow-white",
        pollStyleKey: "invite-blur-2",
        backgroundSizeKeyBigScreen: 'cover',
        backgroundSizeKeySmallScreen: 'cover'
    }],
    ['baby-feet-small', {
        filterKeywords: ['baby-shower'],
        picture: '/assets/images/poll-templates/invitation/baby-feet-small.webp',
        colorPalette: "red-black-yellow",
        pollStyleKey: "invite-background-white-transparent",
        backgroundSizeKeyBigScreen: 'repeat',
        backgroundSizeKeySmallScreen: 'repeat'
    }],
])



